import session from "../util/session";
import { SettingService } from "./settings";

export class AuthService {
  static getToken = () => {
    return session.get(SettingService.integrationServiceBaseUrl + "/token");
  };
}
